import { useTranslation } from './useTranslation';
import { formatTime as formatTimeHelper } from '@/app/helpers/formatTime';
import { DateType } from '@/app/models/date';

/**
 * Custom hook to format time with automatic translations
 * Usage: const formattedTime = useFormatTime(createdAt);
 */
export const useFormatTime = (createdAt: DateType): string => {
    const { t } = useTranslation();

    return formatTimeHelper(createdAt, {
        just_now: t('just_now', '방금 전'),
        minute_ago: t('minute_ago', '1분 전'),
        minutes_ago: t('minutes_ago', '분 전'),
        hour_ago: t('hour_ago', '1시간 전'),
        hours_ago: t('hours_ago', '시간 전'),
        day_ago: t('day_ago', '1일 전'),
        days_ago: t('days_ago', '일 전'),
        week_ago: t('week_ago', '1주 전'),
        weeks_ago: t('weeks_ago', '주 전'),
        year_ago: t('year_ago', '1년 전'),
        years_ago: t('years_ago', '년 전'),
    });
};
